'use strict';

const _ = require('underscore');
const Base = require('components/Base/Base');

require('./IndexTailoredGreenSvg.less');

const Selectors = {
    el: '.IndexTailoredGreenSvg',
    maskPaths: '.IndexTailoredGreenSvg-mask path',
    circleFill: '.IndexTailoredGreenSvg-circleFill',
    circleStroke: '.IndexTailoredGreenSvg-circleStroke'
};

const BindFunctions = [
    'setPathMasksDasharray',
    'setCirclesAnimationDelay'
];

module.exports = Base.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        Base.prototype.initialize.call(this, options);
        _.bindAll(this, BindFunctions);

        setTimeout(() => {
            this.setPathMasksDasharray();
            this.setCirclesAnimationDelay();
        }, 1000);
    },

    setCirclesAnimationDelay: function () {
        this.$(Selectors.circleFill).each((index, fill) => {
            const $fill = $(fill);
            const $stroke = $(fill).next(Selectors.circleStroke);
            const delayFill = 9.5 * Math.random() + 1;
            $fill.css('animation-delay', `${delayFill}s`);
            $stroke.css('animation-delay', `${(delayFill + 2.4)}s`);
        });
    },

    setPathMasksDasharray: function () {
        this.$paths = this.$(Selectors.maskPaths);
        this.$paths.each((index, path) => {
            const length = path.getTotalLength();
            $(path).css('stroke-dasharray', `${length}`);
            $(path).css('stroke-dashoffset', `${length * 2}`);
        });
    }
});
